export const addMinutesToTime = (
  timeString: string,
  minutesToAdd: number
): string => {
  // Create a Date object from the ISO 8601 string
  const date = new Date(timeString);

  // Add the specified minutes
  date.setMinutes(date.getMinutes() + minutesToAdd);

  // Return the updated time in the same ISO 8601 format
  return date.toISOString();
};

export const formatTime = (time: Date) => {
  //convert date into format : 12:00 AM
  return time.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateInDoctorTimeZone = (date: Date): string => {
  //convert date into format : 2021-08-10 and in ASIA/KOLKATA timezone
  return date.toLocaleDateString("en-CA", {
    timeZone: "Asia/Kolkata",
  });
};

export const getLongFormattedDate = (date: Date) => {
  //convert date into format : Tuesday, 10 August 2021
  return date.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
